/** @jsxImportSource @emotion/react */
import { Box, useTheme } from '@mui/material'
import {
  infoPanelTabs,
  sideDrawerContentContainer,
  tabsContainer,
} from './SideDrawerContent.styles'
import { Tabs } from '@app/components/Molecules/Tabs'
import { useState } from 'react'
import { InputsTab } from './InputsTab'
import { ResultsTab } from './ResultsTab'
import { Icon } from '@app/components/Atoms/Icon'

interface SideDrawerContentProps {
  openWizard: () => void
  hideContent?: boolean
}

export const SideDrawerContent = ({ hideContent }: SideDrawerContentProps) => {
  const theme = useTheme()
  const [currentTabIndex, setCurrentTabIndex] = useState(0)

  const switchToResultsTab = () => {
    setCurrentTabIndex(1)
  }

  const tabs = [
    {
      label: 'Inputs',
      icon: <Icon iconName="s3://inputs" colour="#fff" />,
      content: (
        <Box sx={{ flexGrow: 1, height: '100%' }}>
          <InputsTab hideContent={hideContent} switchToResultsTab={switchToResultsTab}></InputsTab>
        </Box>
      ),
      value: 'inputs',
    },
    {
      label: 'Results',
      icon: <Icon iconName="s3://results" colour="#fff" />,
      content: (
        <Box sx={{ overflowY: 'auto', flexGrow: 1 }}>
          <ResultsTab></ResultsTab>
        </Box>
      ),
      value: 'results',
    },
  ]
  return (
    <Box css={sideDrawerContentContainer()}>
      <Box css={tabsContainer}>
        <Tabs
          css={infoPanelTabs({ theme })}
          handleChangeTab={(index) => setCurrentTabIndex(index)}
          tabs={tabs}
          color="uintel"
          tabIndex={currentTabIndex}
        />
      </Box>
    </Box>
  )
}
